// Incremental Server-Sent-Events parser (ENG-1029) — the app's first SSE
// consumer, kept as a pure module so the wire format is unit-testable without a
// stream. Feed it decoded text chunks in arrival order; it yields the `data:`
// payloads of complete events and buffers partials across chunk boundaries.
//
// Deliberately minimal: the agent endpoint only ever emits `data:` lines and
// `: keep-alive` comments, so event/id/retry fields are out of scope. `[DONE]`
// is the terminator sentinel (OpenAI convention, matched server-side).

export function createSseParser() {
  let buf = ''
  return {
    /** Push one decoded text chunk; returns the data payloads completed by it. */
    push(chunk) {
      buf += chunk
      const out = []
      let nl
      while ((nl = buf.indexOf('\n')) >= 0) {
        const line = buf.slice(0, nl).replace(/\r$/, '')
        buf = buf.slice(nl + 1)
        if (line.startsWith('data:')) out.push(line.slice(5).trim())
      }
      return out
    },
    /** Flush a trailing unterminated data line (stream ended without \n). */
    end() {
      const line = buf.replace(/\r$/, '')
      buf = ''
      return line.startsWith('data:') ? [line.slice(5).trim()] : []
    },
  }
}

/** Parse the agent's JSON event payloads, dropping the [DONE] sentinel and
 * anything unparseable (a proxy's keep-alive junk must not kill the stream). */
export function parseAgentEvents(dataPayloads) {
  const events = []
  for (const d of dataPayloads) {
    if (d === '[DONE]') continue
    try { events.push(JSON.parse(d)) } catch { /* not an event — ignore */ }
  }
  return events
}
